/* unplugin-vue-components disabled */import { ElResult as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/result/style/css';
import { ElPagination as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/base/style/css';import 'element-plus/es/components/pagination/style/css';
import _regeneratorRuntime from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/Zhuanz/Desktop/source/iafme_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.function.name.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, isRef as _isRef, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue";
var _hoisted_1 = {
  "class": "iamfe"
};
var _hoisted_2 = {
  "class": "nav-text"
};
var _hoisted_3 = {
  "class": "newslist"
};
var _hoisted_4 = {
  "class": "list"
};
var _hoisted_5 = {
  "class": "shows"
};
var _hoisted_6 = ["onClick"];
var _hoisted_7 = {
  "class": "news_content"
};
var _hoisted_8 = ["src", "alt"];
var _hoisted_9 = {
  "class": "con_right"
};
var _hoisted_10 = {
  key: 0,
  "class": "pagelist"
};
var _hoisted_11 = {
  key: 0,
  "class": "newslist noData"
};
import eventBus from '../event/mitt';
import { getCawListApi } from '@/api/home/news';
import router from '@/router';
export default /*@__PURE__*/_defineComponent({
  __name: 'SearchTitle',
  setup: function setup(__props) {
    var route = useRoute();
    var total = ref(0);
    var currentPage = ref(1);
    var cawPram = ref({
      name: '',
      pageNum: currentPage.value,
      pageSize: 10
    });
    var dataSource = ref([]);
    onMounted(function () {
      cawPram.value.name = route.query.keyName;
      getDataLists();
    });
    eventBus.on('searchName', function (data) {
      cawPram.value.name = data;
      getDataLists();
    });
    function getDataLists() {
      return _getDataLists.apply(this, arguments);
    }
    function _getDataLists() {
      _getDataLists = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var result, _result$data$total, _result$data$current, _result$data$records;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return getCawListApi(cawPram.value);
            case 2:
              result = _context.sent;
              if (result.code == 200) {
                total.value = (_result$data$total = result.data.total) !== null && _result$data$total !== void 0 ? _result$data$total : 0;
                currentPage.value = (_result$data$current = result.data.current) !== null && _result$data$current !== void 0 ? _result$data$current : 1;
                dataSource.value = (_result$data$records = result.data.records) !== null && _result$data$records !== void 0 ? _result$data$records : [];
              } else {
                ElMessage.error('获取失败');
              }
            case 4:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return _getDataLists.apply(this, arguments);
    }
    function handelCurrentChange(pageNum) {
      cawPram.value.pageNum = pageNum;
      getDataLists();
    }
    function checkItem(item) {
      router.push("/cwaItem/".concat(item.id, "/").concat(item.type));
    }
    return function (_ctx, _cache) {
      var _component_el_pagination = __unplugin_components_0;
      var _component_el_result = __unplugin_components_1;
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", null, "当前位置：首页>搜索关键词:" + _toDisplayString(_unref(cawPram).name), 1)]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createElementVNode("ul", _hoisted_5, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dataSource), function (item) {
        return _openBlock(), _createElementBlock("li", {
          key: item.id
        }, [_createElementVNode("a", {
          target: "",
          onClick: function onClick($event) {
            return checkItem(item);
          },
          style: {
            "cursor": "pointer"
          }
        }, [_createElementVNode("h3", null, _toDisplayString(item.name), 1), _createElementVNode("div", _hoisted_7, [_createElementVNode("img", {
          src: item.image,
          alt: item.name
        }, null, 8, _hoisted_8), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", null, _toDisplayString(item.name), 1), _createElementVNode("div", null, [_cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1)), _cache[2] || (_cache[2] = _createElementVNode("span", null, null, -1)), _createElementVNode("span", null, _toDisplayString(item.createTime), 1)])])])], 8, _hoisted_6)]);
      }), 128))])]), _unref(dataSource).length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_10, [_createVNode(_component_el_pagination, {
        background: "",
        layout: "prev, pager, next",
        "current-page": _unref(currentPage),
        "onUpdate:currentPage": _cache[0] || (_cache[0] = function ($event) {
          return _isRef(currentPage) ? currentPage.value = $event : null;
        }),
        onCurrentChange: handelCurrentChange,
        total: _unref(total)
      }, null, 8, ["current-page", "total"])])) : _createCommentVNode("", true)]), _unref(dataSource).length == 0 ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_createVNode(_component_el_result, {
        icon: "info",
        title: "未查询找到数据",
        "sub-title": "请重新搜索"
      })])) : _createCommentVNode("", true)]);
    };
  }
});